<template>
  <el-dialog
      title="栏目编辑"
      :visible.sync="dialogVisible"
      @open="getCategory"
      @close="handleClose"
      >
    <el-form ref="form" :model="form" label-width="100px">
      <input type="hidden" v-model="form.id" />
      <el-form-item label="标题">
        <el-input v-model="form.file_name"></el-input>
      </el-form-item>
      <el-form-item label="副标题">
        <el-input type="textarea" :rows="2"  v-model="form.file_text" placeholder=""></el-input>
      </el-form-item>
      <el-form-item label="ALT">
        <el-input type="textarea" :rows="2"  v-model="form.file_alt" placeholder=""></el-input>
      </el-form-item>
      <el-form-item label="简介">
        <el-input type="textarea" :rows="2"  v-model="form.file_desc" placeholder=""></el-input>
      </el-form-item>

<!--      <el-form-item label="正文">-->
<!--        <div style="border: 1px solid #ccc;">-->
<!--          <Toolbar-->
<!--              style="border-bottom: 1px solid #ccc"-->
<!--              :editor="editor"-->
<!--              :defaultConfig="toolbarConfig"-->
<!--              :mode="mode"-->
<!--          />-->
<!--          <Editor-->
<!--              style="height: 500px; overflow-y: hidden;"-->
<!--              v-model="form.file_text"-->
<!--              :defaultConfig="editorConfig"-->
<!--              :mode="mode"-->
<!--              @onCreated="onCreated"-->
<!--          />-->
<!--        </div>-->
<!--      </el-form-item>-->
      <el-form-item>
        <el-button type="primary" @click="onSubmit">保存</el-button>
        <el-button @click="handleClose">取消</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>

</template>

<script>
import axios from "axios";
// import { Editor, Toolbar } from '@wangeditor/editor-for-vue'

export default {
  name: "getFileView",
  // components: { Editor, Toolbar },
  data(){
    return{
      dialogVisible:this.show,
      fileList:[],
      form: {
        id: "",
        file_name: "",
        file_alt: "",
        file_desc: "",
        file_text: ""
      },
      editor: null,
      toolbarConfig: { },
      editorConfig: {
        placeholder: '请输入内容...',
        MENU_CONF: {
          'uploadImage': {
            // customUpload: this.uploadImg,
            server: '/api/Upload/uploadEditor.html',
            fieldName: 'image[]',
            maxFileSize: 2 * 1024 * 1024, // 2M
            maxNumberOfFiles: 50,
            allowedFileTypes: ['image/*'],
            timeout: 5 * 1000, // 5 秒
          },
          'uploadVideo': {
            // customUpload: this.uploadImg,
            server: '/api/Upload/editorFile.html',
            withCredentials: true,
            fieldName: 'files[]',
            maxFileSize: 200 * 1024 * 1024, // 200M
            // maxNumberOfFiles: 3,
            // allowedFileTypes: ['video/*'],
            // timeout: 15 * 1000, // 5 秒
          }
        }
      },
      mode: 'default', // or 'simple'
    }
  },
  watch:{
    show(val){
      this.dialogVisible = val
      // this.resetData();
    }
  },
  props:{
    show: {
      type: Boolean,
      default: false
    },
    url:{
      type: String,
      default: ''
    }
  },
  beforeDestroy() {
    const editor = this.editor
    if (editor == null) return
    editor.destroy() // 组件销毁时，及时销毁编辑器
  },
  methods:{
    onCreated(editor) {
      this.editor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
    },
    handleClose() {
      this.$emit("dialogShowChange",false);
      this.resetData()
    },
    getCategory() {
      let url = this.$props.url;
      if(url){
        axios.get('/api/File/getFile.html?url='+url).then((res)=>{
          if(res.data.code == 200){
            this.form = res.data.data;
          }
        });
      }
    },
    resetData(){
      this.form = this.$options.data().form;
    },
    onSubmit() {
      axios({
        method:'post',
        url:'/api/File/setFile.html',
        data:this.form
      }).then((res)=>{
        if(res.data.code != 200) {
          alert(res.data.msg);
        }
        else{
          alert(res.data.msg);
          this.handleClose();
        }
      })
    },
  }
}
</script>
<style src="@wangeditor/editor/dist/css/style.css"></style>
<style scoped>

</style>